import { TennEntityType } from "./MoneyTransferModal";

export interface Entity {
  entityType: EntityType;
  entityId: number;
  flexCubeBranchCode: string;
  flexCubeCbsId: string;
  customerNumber: string;
  customerAccount: string;
  customerAccountCurrency: string;
  iban: string;
  bic: string;
  entityName: string;
  customerAddress: string;
  minimumTransactionAmount: number;
}

export enum TransferType {
  ThirdPartyTransfer = 1,
  Withdrawal = 2,
  P2P = 3
}

export enum ServiceClients {
  WalletApp10n = 0,
  OpenBanking = 1,
  MerchantPayment = 2
}

export enum SourceOfFundsStatuses {
  None = 0,
  NotRequired = 1,
  Required = 2,
  Provided = 3,
  Verified = 4
}

export enum ScaStatuses {
  None = 0,
  Pending = 1,
  Initiated = 2,
  Confirmed = 3
}

export enum SettlementStatuses {
  None = 0,
  Pending = 1,
  Executed = 2,
  Rejected = 3,
  Returned = 4
}

export enum ReviewStatuses {
  None = 0,
  Required = 1,
  RequiredStopNext = 2,
  Approve = 10,
  Reject = 11
}

export enum AmountBlockStatuses {
  None = 0,
  Held = 1,
  Released = 2,
  CreateFailed = 3,
  ReleaseFailed = 4
}

export enum ReconciliationStatuses {
  None = 0,
  Required = 1,
  Resolved = 2
}

export enum RiskDecisionFamilies {
  Unknown = "Unknown",
  AMLScreening = "AMLScreening",
  MonitoringSecurity = "MonitoringSecurity"
}

export interface BankTransferOutgoing {
  id: number;
  tenantId: number;
  sender: Entity;
  recipient: Entity;
  transferType: TransferType;
  serviceClient: ServiceClients;
  amount: number;
  currency: string;
  amountBgn?: number;
  amountEur?: number;
  chargeAmount: number;
  chargeCurrency?: string;
  paymentNotes?: string;
  network: string;
  paymentSystem?: string;
  calculatedPaymentType?: string;
  calculatedPaymentTypeCode: string;
  status: BankTransferStatus;
  riskStatusAuto: RiskStatusesAuto;
  riskDecisionFamily: RiskDecisionFamilies | string;
  riskReasonCode: string;
  riskReasonText: string;
  riskRulesInfo: string;
  riskNotes: string;
  sourceOfFundsStatus: SourceOfFundsStatuses;
  scaStatus: ScaStatuses;
  settlementStatus: SettlementStatuses;
  reviewStatus: ReviewStatuses;
  reviewResolution: ReviewRosulutionStatuses;
  reviewDecisionBy: string;
  reviewDecisionAt?: string;
  flexCubePaymentReference: string;
  amountBlockNumber: string;
  amountBlockStatus: AmountBlockStatuses;
  amountBlockAmount?: number;
  amountBlockCurrency: string;
  amountBlockCreatedAt?: string;
  amountBlockReleasedAt?: string;
  amountBlockExpiresAt?: string;
  amountBlockLastSyncedAt?: string;
  amountBlockRetryCount: number;
  amountBlockLastError: string;
  amountBlockWarningCode: string;
  amountBlockWarningText: string;
  customerOutgoingFreezeActive: boolean;
  customerOutgoingFreezeId?: number;
  customerOutgoingFreezeReasonCode: string;
  customerOutgoingFreezeReasonText: string;
  customerOutgoingFreezeCheckedAt?: string;
  reconciliationStatus: ReconciliationStatuses;
  reconciliationReason: string;
  reconciliationUpdatedAt?: string;
  createDate: string; // ISO string format
  executeOrderDate?: string;
  executionDate?: string;
  settlementDate?: string;
}

export enum SourceOfFundsStatus {
  " " = 0,
  "NotRequired" = 1,
  "Required" = 2,
  "Provided" = 3,
  "Verified" = 4
}

export enum BankTransferStatus {
  " " = 0,
  "Initiated" = 1,
  "PendingExecution" = 2,
  "Rejected" = 3,
  "Canceled" = 4,
  "Executed" = 5,
  "RejectedByBorika" = 6,
  "ReturnedToCustomer" = 7
}

export enum RiskStatusesAuto {
  " " = 0,
  "Approve" = 1,
  "Reject" = 2,
  "Review" = 3
}

export enum ReviewStatus {
  " " = 0,
  "Required" = 1,
  "RequiredStopNext" = 2,
  "Approve" = 10,
  "Reject" = 11
}

export enum ReviewRosulutionStatuses {
  " " = 0,
  "Approve" = 1,
  "Reject" = 2
}

export enum EntityType {
  "Individual" = 1,
  "Merchant" = 2
}

export enum BankTransferResponceCode {
  OK = 0,
  RiskReject = 1,
  SourceOfFundsRequired = 2
}

export interface BankTransferReviewRequest {
  sourceEntityType: EntityType;
  sourceEntityId: number;
  transferId: number;
  reviewResolution: ReviewRosulutionStatuses;
}

export interface BankTransferResult {
  sourceEntityType: EntityType;
  sourceEntityId: number;
  transferId: number;
  responceCode: BankTransferResponceCode;
  referenceNumber: string;
}

export interface PaymentRequestPendingReview {
  paymentRequestId: string;
  createdAtUtc: string;
  updatedAtUtc: string;
  senderName: string;
  senderEntityId?: number;
  beneficiaryName: string;
  amount: number;
  currency: string;
  routeId: string;
  destinationCountry: string;
  riskDecisionFamily?: string;
  riskReasonCode?: string;
  riskReasonText?: string;
}

export interface PaymentRequestReviewResolutionRequest {
  reviewResolution: ReviewRosulutionStatuses;
}

export interface PaymentRequestReviewResolutionResult {
  paymentRequestId: string;
  status: string;
  message: string;
  nextAction: string;
}

export interface SourceOfFundsUploadRequest {
  sourceEntityType: EntityType | TennEntityType;
  sourceEntityId: number;
  transferId: number;
  fileName: string;
  fileData: string;
}


export interface BankTransferRequestModel {
	sourceEntityType: TennEntityType;
	sourceEntityId: number;
	transferId: number;
}

export interface AddBankTransferOutgoing {
  prop: string
}

export interface BankTransferRequest {
  sourceEntityType: EntityType;
  sourceEntityId: number;
  transferId: number;
}

export interface CustomerOutgoingFreezeRequest {
  sourceEntityType: EntityType;
  sourceEntityId: number;
  tenantId: number;
  reasonText?: string;
  caseId?: string;
}

export interface CustomerOutgoingFreezeState {
  id: number;
  customerId: number;
  tenantId: number;
  isActive: boolean;
  sourceSystem: string;
  decisionFamily: string;
  reasonCode: string;
  reasonText: string;
  triggeredRuleCodes: string[];
  relatedTransactionId?: number;
  caseId: string;
  activatedBy: string;
  activatedAt?: string;
  releasedBy: string;
  releasedAt?: string;
  releaseReason: string;
}

export enum DocumentStatus {
  "New" = 0,
  "Approved" = 1,
  "Declined" = 2
}

export interface BankTransferSourceOfFunds {
  id: number | null;
  bankTransferId: number | null;
  entityType: EntityType | null;
  entityId: number | null;
  fileName: string;
  fileStorageId: string;
  status: DocumentStatus;
  reviewComments: string;
  uploadDate: Date | null;
  file: File | null;
  documentType: string;
  isUploaded: boolean;
  isModified: boolean;
  objectURL: string | null;
}
